export const ACH_DISCOUNT_RATE = 0.01;

export function roundMoney(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return 0;
  return Math.round(amount * 100) / 100;
}

export function formatDiscountPercent(value) {
  const rounded = Math.round((Number(value) || 0) * 100) / 100;
  if (!Number.isFinite(rounded) || rounded <= 0) return "0";
  if (Math.abs(rounded - Math.round(rounded)) < 0.001) {
    return String(Math.round(rounded));
  }
  return rounded.toFixed(2).replace(/0+$/, "").replace(/\.$/, "");
}

/**
 * Coupon percent and the ACH 1% are added together on the original amount.
 * A 5% coupon plus ACH is a 6% discount, not 1% of the post-coupon total.
 */
export function stackedDiscount({ base, couponAmount, achSelected }) {
  const safeBase = Math.max(roundMoney(base), 0);
  const coupon = Math.min(safeBase, Math.max(roundMoney(couponAmount), 0));
  const achAmount = achSelected ? roundMoney(safeBase * ACH_DISCOUNT_RATE) : 0;
  const totalAmount = Math.min(safeBase, roundMoney(coupon + achAmount));
  const totalPercent = safeBase > 0 ? (totalAmount / safeBase) * 100 : 0;

  return {
    couponAmount: coupon,
    achAmount,
    totalAmount,
    totalPercent,
    percentLabel: formatDiscountPercent(totalPercent),
    payable: roundMoney(safeBase - totalAmount),
  };
}
